import React from 'react';
import { useStyletron } from 'baseui';
import { Input } from 'baseui/input';
import { DatePicker } from 'baseui/datepicker';
import { Spinner } from 'baseui/spinner';
import { Pagination } from 'baseui/pagination';
import useHistoryHook from './useHistory';
import ChangeTimeline from './ChangeTimeline';

const ConfigHistory: React.FC<{}> = () => {
	const [css] = useStyletron();
	const { changes, totalCount, loading, page, setPage, pageSize, filters, updateFilter } = useHistoryHook();

	const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

	return (
		<div className={css({ padding: '24px' })}>
			<h2 className={css({ marginTop: '0', marginBottom: '24px' })}>Config Change History</h2>

			{/* Filters */}
			<div
				className={css({
					display: 'grid',
					gridTemplateColumns: '1fr 1fr 1fr',
					gap: '16px',
					marginBottom: '24px',
					padding: '16px',
					backgroundColor: '#FAFAFA',
					borderRadius: '8px',
					border: '1px solid #E2E2E2'
				})}>
				<div>
					<label className={css({ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 500 })}>
						Key Name
					</label>
					<Input
						value={filters.key}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateFilter('key', e.target.value)}
						placeholder='Search by key name...'
						size='compact'
					/>
				</div>
				<div>
					<label className={css({ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 500 })}>
						From Date
					</label>
					<DatePicker
						value={filters.from ? new Date(filters.from) : undefined}
						onChange={({ date }) => {
							const d = Array.isArray(date) ? date[0] : date;
							updateFilter('from', d ? d.toISOString() : '');
						}}
						formatString='yyyy-MM-dd'
						size='compact'
					/>
				</div>
				<div>
					<label className={css({ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 500 })}>
						To Date
					</label>
					<DatePicker
						value={filters.to ? new Date(filters.to) : undefined}
						onChange={({ date }) => {
							const d = Array.isArray(date) ? date[0] : date;
							updateFilter('to', d ? d.toISOString() : '');
						}}
						formatString='yyyy-MM-dd'
						size='compact'
					/>
				</div>
			</div>

			{/* Content */}
			{loading ? (
				<div className={css({ display: 'flex', justifyContent: 'center', padding: '48px' })}>
					<Spinner />
				</div>
			) : (
				<>
					<ChangeTimeline changes={changes} />
					{totalPages > 1 && (
						<div className={css({ display: 'flex', justifyContent: 'center', marginTop: '24px' })}>
							<Pagination numPages={totalPages} currentPage={page} onPageChange={({ nextPage }) => setPage(nextPage)} />
						</div>
					)}
				</>
			)}
		</div>
	);
};

export default ConfigHistory;
